import { Component, OnInit } from '@angular/core';
import { Company } from '../../../models/company';

import { AuthService } from '../../../services/auth.service';
import { CompanyService } from '../../../services/company.service';
import { CustomerTypeService } from '../../../services/customer-type.service';
import { Router } from '@angular/router';

import { saveAs as importedSaveAs } from 'file-saver';

import { Page } from '../../../models/paging/page';
import { Customer_Type } from '../../../models/customer_Type';
import { ExpiredGasReportService } from '../../../services/expired-gas-report.service';
import { ColumnService } from '../../../services/ColumnService';

@Component({
  selector: 'app-expired-gas-report',
  templateUrl: './expired-gas-report.component.html',
  styleUrls: ['./expired-gas-report.component.css']
})
export class ExpiredGasReportComponent implements OnInit {

  companyService: CompanyService;

  customerTypes: Customer_Type[];

  companies: Company[];
  companyList: Company[];

  filter: any = {
    customer_Type_Id: 0,
    company_Id: 0,
    quick_Search: ""
  };

  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;
  is_client = false;
  client;

  availableOptions: string[] = [
    'Serial #', 
    'Cyl Size', 
    'Product Type', 
    'Cyl Material', 
    'Company Name', 
    'Location', 
    'Last Filled At', 
    'Tag ID', 
    'Batch #', 
    'Last Delivered At'
];

selectedOptions: string[] = [
  'Serial #', 
  'Cyl Size', 
  'Product Type', 
  'Cyl Material', 
  'Company Name', 
  'Location', 
  'Last Filled At', 
  'Tag ID', 
  'Batch #', 
  'Last Delivered At'
];

  showPopup: boolean = false;
  popupContent: string = '';

  constructor(authService: AuthService, companyService: CompanyService, public expiredGasReportService: ExpiredGasReportService,
    customerTypeService: CustomerTypeService, public router: Router, private columnService: ColumnService) {

    this.is_client = authService.currentUser.value.userType == 0;
    this.client = authService.currentUser.value;
   
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "";

    customerTypeService.getAll().then((data) => {
      this.customerTypes = data;
    });

    companyService.getAll(this.filter.customer_Type_Id).then((data) => {
      this.companyList = data;
      this.companies = this.companyList;
      if (this.is_client) {
        this.filter.company_Id = authService.currentUser.value.company_Id;
        this.filter.location_Id = authService.currentUser.value.location_Id;
      }
      
      //this.loadTable(this.page);
    });

    this.companyService = companyService;

  }

  ngOnInit() {
    /*this.loadTable(this.page);*/
    this.getcolumns();
    this.init = true;
  }

  // ###################################
  // Filters
  // ###################################
  onCompanyChange(value) {
    if (value == 0) { value = null; }
  }

  onCustomerTypeChange(value) {
    this.filter.company_Id = 0;
    this.onCompanyChange(0);

    if (value == 0) { value = null; }

    this.companies = this.companyList.filter(c => {
      return value == null || c.customer_Type_Id == value;
    });

  }

  // ###################################
  // TABLE
  // ################################### 
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.expiredGasReportService.getResults(this.page, this.filter.company_Id, this.filter.quick_Search).then((pagedData) => {
        this.page = pagedData.page;
        this.rows = pagedData.data;
        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  generateExcel() {
    this.expiredGasReportService.getExcel(this.filter.company_Id).then((data) => {
        importedSaveAs(data, 'Expired_Gas.xlsx');
      });
  }

  gotoTop() {
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    this.columnService.getColumns(this.client.userId, "expiredGasReport").then((data) => {
      if (data.columns != null) {
        
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }

    });
  }

  saveSelection() {
    this.columnService.save(this.client.userId, "expiredGasReport", this.selectedOptions).then((data) => {
    });
  }
}

